import { render, staticRenderFns } from "./Islas.vue?vue&type=template&id=9d8a3d58&scoped=true"
import script from "./Islas.vue?vue&type=script&lang=js"
export * from "./Islas.vue?vue&type=script&lang=js"
import style0 from "./Islas.vue?vue&type=style&index=0&id=9d8a3d58&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d8a3d58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node-apps/im.ingenes.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9d8a3d58')) {
      api.createRecord('9d8a3d58', component.options)
    } else {
      api.reload('9d8a3d58', component.options)
    }
    module.hot.accept("./Islas.vue?vue&type=template&id=9d8a3d58&scoped=true", function () {
      api.rerender('9d8a3d58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admin/Islas.vue"
export default component.exports